import { render, staticRenderFns } from "./PopupRomeDesc.vue?vue&type=template&id=65b3e7e3&"
import script from "./PopupRomeDesc.vue?vue&type=script&lang=js&"
export * from "./PopupRomeDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports